import gsap from 'gsap';

const aiApp = () => {
    const appWrapper = document.querySelector('#ai-app');
    const stepTriggers = document.querySelectorAll('.step-trigger');

    // Screen 2
    const tracksItems = document.querySelectorAll('.ai-track__track-item');
    const tracksTriggers = document.querySelectorAll('.ai-track__track-trigger');

    //Misc mobile helpers
    const isMobile = window.innerWidth < 1200;

    // If we don't have the main wrapper, or screen is small exit early
    if (!appWrapper) return;

    appWrapper.classList.add('is-active');

    if (window.innerWidth < 1200) {
        //Misc mobile helpers
        const trackModalRevealButtons = document.querySelectorAll(".ai-track__content-slide-cta-button");
        const trackModalResetButtons = document.querySelectorAll(".ai-track__reset-app");
        const trackModalUnRevealButtons = document.querySelectorAll(".ai-track__back-arrow");
        const accordionToggleButton = document.querySelectorAll(".ai-track-accordion-button");

        trackModalRevealButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const container = button.closest('.ai-track-view-mobile');
                const idx = parseInt(button.dataset.index);
                const target = container.querySelector(`.ai-track__content-modal[data-index="${idx}"]`);

                document.querySelector('.ai-track__content-modal.is-active')?.classList.remove('is-active');

                target.classList.add('is-active');
            });
        });

        trackModalUnRevealButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const target = document.querySelector('.ai-track__content-modal.is-active');
                target.classList.remove('is-active');
            });
        });

        trackModalResetButtons.forEach((button) => {
            const sectionTop = document.getElementById("ai-app-mobile");

            button.addEventListener('click', () => {
                document.querySelectorAll('.ai-track-accordion-mobile-outer.is-active').forEach(el => {
                    el.classList.remove('is-active');
                });

                window.scrollTo({
                    top: sectionTop,
                    behavior: "smooth"
                });
            });
        });

        accordionToggleButton.forEach((button) => {
            button.addEventListener('click', (e) => {
                button.nextElementSibling.classList.toggle('is-active');
            });
        });

        return;
    }

    // Screen references:
    // - Screen 1: "Splash"
    // - Screen 2: "Tracks / Overview"
    // - Screen 3: Track

    // ------------------------------------------------
    // Step triggers: set the active screen
    // ------------------------------------------------
    stepTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            // (Optionally get the current step if needed)
            const currentStep = appWrapper.dataset.step;
            appWrapper.dataset.step = trigger.dataset.step;
        });
    });

    // ------------------------------------------------
    // Screen 2 - Track selection
    // ------------------------------------------------
    tracksTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            trigger.classList.add('is-selected');
            const target = trigger.dataset.track;
            const index = trigger.dataset.index;
            const container = document.getElementById(target);
            const tracks = document.querySelectorAll('.ai-track-view');

            tracks.forEach((el) => {
                el.classList.remove('is-active');
            });

            container.classList.add('is-active');

            setTimeout(() => {
                initSingleSlideshow(container, index);
            }, 2000);
            return false;
        });
    });

    // ------------------------------------------------
    // Screen 2 - Hover states on track items
    // ------------------------------------------------
    tracksItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            item.classList.add('is-hovered');
        });

        item.addEventListener('mouseleave', () => {
            // Clear any existing timeout (if you were using it)
            if (item.dataset.timeoutId) {
                clearTimeout(item.dataset.timeoutId);
                delete item.dataset.timeoutId;
            }

            item.classList.add('is-leaving', 'is-transitioning');

            const removeClasses = () => {
                item.classList.remove('is-leaving', 'is-hovered', 'is-transitioning');
                item.removeEventListener('animationend', removeClasses);
                item.removeEventListener('transitionend', removeClasses);
            };

            // Listen for the actual end of the transition/animation
            item.addEventListener('animationend', removeClasses);
            item.addEventListener('transitionend', removeClasses);

            // Optional fallback if transitions/animations don't fire:
            // const timeoutId = setTimeout(removeClasses, 1000);
            // item.dataset.timeoutId = timeoutId;
        });
    });

    // ------------------------------------------------
    // Step 3 slideshow functions
    // ------------------------------------------------

    const initSingleSlideshow = (container, index) => {
        const paginationItems = container.querySelectorAll(".ai-track__pagination button");
        const slides = container.querySelectorAll(".ai-track__content-slide");
        const paginateButtons = document.querySelectorAll(".ai-track__paginate");
        const resetButtons = container.querySelectorAll(".ai-track__reset-instance");
        const prevStepButtons = container.querySelectorAll(".ai-track__prev-step");

        let activeIndex = index || 0;
        let isDestroyed = false;

        const updatePaginationPerspective = (duration = 0.5) => {
            if (isDestroyed) return;

            paginationItems.forEach((item, index) => {
                let scale;
                const depth = index - activeIndex;
                const isBefore = depth < 0;
                const isAfter = depth >= 0;

                // Base spacing values
                const baseVert = 38;
                const baseHorz = 125;

                // Scaling logic: No growth for preceding items
                scale = isAfter
                    ? Math.max(1 - Math.abs(depth) * 0.15, 0.5)  // Following items shrink smoothly
                    : 1;  // Preceding items stay full size

                // **Fix Overlap & Uneven Gaps**
                // Ensure a constant spacing ratio to avoid expanding gaps
                const adjustedDepth = depth < 0 ? depth * 1.2 : depth; // Slight extra push for left-side items

                // Keep spacing **LINEAR** and prevent overlap
                const xOffset = adjustedDepth * baseHorz;
                const yOffset = adjustedDepth * -baseVert;

                item.classList.toggle('is-active', index === activeIndex);

                gsap.to(item, {
                    scale,
                    x: xOffset,
                    y: yOffset,
                    opacity: 1,
                    duration: duration,
                    ease: "power2.out"
                });
            });
        };


        const changeSlide = (newIndex) => {
            if (isDestroyed || newIndex === activeIndex || newIndex < 0 || newIndex >= slides.length) return;

            const currentSlide = slides[activeIndex];
            const nextSlide = slides[newIndex];

            const tl = gsap.timeline();

            tl.to(currentSlide, {
                opacity: 0,
                duration: 0.5,
                ease: "power2.inOut",
                onComplete: () => {
                    gsap.set(currentSlide, {x: "100%"});
                }
            });

            tl.fromTo(nextSlide,
                {opacity: 0, x: 0},
                {
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.inOut"
                }
            );

            activeIndex = newIndex;
            updatePaginationPerspective();
        };

        const destroy = () => {
            if (isDestroyed) return;
            isDestroyed = true;

            // Remove event listeners
            // paginationItems.forEach((item, index) => {
            //     item.removeEventListener("click", () => changeSlide(index));
            // });

            // paginateButtons.forEach((button) => {
            //     button.removeEventListener("click", (event) => {
            //         const targetIndex = parseInt(event.currentTarget.getAttribute("data-index"));
            //         changeSlide(targetIndex);
            //     });
            // });

            // resetButtons.forEach((button)=> {
            //     button.removeEventListener("click", destroy);
            // });

            // Reset styles
            slides.forEach((slide) => {
                gsap.to(slide, {
                    opacity: 0,
                    x: "100%",
                    y: 0,
                    duration: 1,
                    ease: "power2.inOut"
                });
            });

            paginationItems.forEach((item, index) => {
                gsap.to(item, {
                    scale: 0,
                    x: 0,
                    y: 0,
                    opacity: 0,
                    duration: 1,
                    ease: "power2.out"
                });
            });
        };

        paginationItems.forEach((item, index) => {
            item.addEventListener("click", () => changeSlide(index));
        });

        paginateButtons.forEach((button) => {
            button.addEventListener("click", (event) => {
                const targetIndex = parseInt(event.currentTarget.getAttribute("data-index"));
                changeSlide(targetIndex);
            });
        });

        prevStepButtons.forEach((button) => {
                const newIndex = parseInt(button.getAttribute("data-index"));
                button.addEventListener("click", () => {
                if (newIndex >= 0) {
                    changeSlide(newIndex);
                }
            });
        });

        resetButtons.forEach((button) => {
            button.addEventListener("click", destroy);
        });


        // Ensure the first slide is visible
        gsap.to(slides[activeIndex], {x: "0%", opacity: 1, duration: 1});

        // Initialize perspective
        updatePaginationPerspective(1);
    };

};

export default aiApp;
